<template>
  <div>
    <div>
      <h5 v-dynamic-content:generic_additional_information_products_title></h5>
      <p v-if="isBattery" v-dynamic-content:battery_additional_information_products></p>
      <p
        v-if="datasheetItems.length"
        v-dynamic-content:generic_additional_information_products="[...datasheetItems]"
      ></p>
      <template v-if="warrantyItems.length">
        <h5 v-dynamic-content:generic_additional_information_warranty_title></h5>
        <p v-if="isBattery" v-dynamic-content:battery_additional_information_warranty_text1></p>
        <p v-dynamic-content:generic_additional_information_warranty_intro></p>
        <ul>
          <li
            v-for="(item, i) in warrantyItems"
            :key="i"
            v-dynamic-content:generic_additional_information_warranty_list="[
              pickProductName(item),
              item.warranty,
            ]"
          ></li>
        </ul>
        <p v-if="isBattery" v-dynamic-content:battery_additional_information_warranty_text2></p>
      </template>
      <div v-if="isBattery">
        <h5 v-dynamic-content:pv_savings_battery_subsidy_modal_title></h5>
        <p
          v-dynamic-content:generic_savings_battery_subsidy="[batteryCapacity, batterySubsidy]"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['quote'],
  name: 'CardAdditionalInformation',
  computed: {
    ...mapGetters([
      'isBattery', 
      'language'
    ]),
    warrantyItems() {
      return this.quote.items.filter((i) => i.warranty)
    },
    datasheetItems() {
      return this.quote.items
        .filter((i) => i.datasheet)
        .map((i) => `<a target="_blank" href="${i.datasheet}">${this.pickProductName(i)}</a>`)
        .join(', ')
    },
    batteryCapacity() {
      return this.$options.filters.formatKwh(this.quote.detailOverview.batteryCapacity, 1)
    },
    batterySubsidy() {
      return this.$options.filters.formatCurrency(this.quote.detailOverview.batterySubsidy)
    },
  },
}
</script>
